///////////////////////////////////////////////////////////////////////////////////
// Retrieve NOUS API Key
////////////////////////////////////////////////////////////////////////////////////
var nous_api_data;
// jQuery.ajax({
//      type: "POST",
//      // async: false,
//      url: '/wp-admin/admin-ajax.php',
//      dataType: 'json',
//      data: {
//       'action' : 'nous_retrieve_api_data',
//      },
//      success:function(response) {

//         ////////////////////////////////////////////////////////////////////////////////////
//         // Set API Data
//         ////////////////////////////////////////////////////////////////////////////////////
//         nous_api_data = response;

//         ////////////////////////////////////////////////////////////////////////////////////
//         // Set Global Ajax Settings
//         ////////////////////////////////////////////////////////////////////////////////////
//         jQuery.ajaxSetup({
//           headers: {
//             'X-Api-Key': response.client_key,
//           }
//         });

//         ////////////////////////////////////////////////////////////////////////////////////
//         // Display Forms
//         ////////////////////////////////////////////////////////////////////////////////////
//         jQuery('form').css('opacity', '1');

//      },
// });

////////////////////////////////////////////////////////////////////////////////////
// Persistant Session Storage
////////////////////////////////////////////////////////////////////////////////////
if (!sessionStorage.length) {
  // Ask other tabs for session storage
  localStorage.setItem('getSessionStorage', Date.now());
};

window.addEventListener('storage', function(event) {

  if (event.key == 'getSessionStorage') {

    localStorage.setItem('sessionStorage', JSON.stringify(sessionStorage));
    localStorage.removeItem('sessionStorage');

  } else if (event.key == 'sessionStorage' && !sessionStorage.length) {
    // sessionStorage is empty -> fill it

    var data = JSON.parse(event.newValue),
          value;

    for (key in data) {
      sessionStorage.setItem(key, data[key]);
    }

  }
});

////////////////////////////////////////////////////////////////////////////////////
// Generate Google reCaptcha V3 Token
////////////////////////////////////////////////////////////////////////////////////
function generate_google_recaptcha_token(action) {
  return new Promise(function(resolve, reject) {
      grecaptcha.execute(jQuery('body').attr('data-recaptcha-key'), {
        action: action
      })
      .then(function(token) {

        ////////////////////////////////////////////////////////////////////////////////////
        // Ajax - Validate Response
        ////////////////////////////////////////////////////////////////////////////////////
        jQuery.ajax({
          type: "POST",
          url: '/wp-admin/admin-ajax.php',
          data: {
            'action':'ajax_recaptcha_validate',
            'captcha_token' : token,
            'captcha_action' : action,
          },
          success:function(response) {
            resolve(response);
          }
        });
      });
  });
}

////////////////////////////////////////////////////////////////////////////////////
// Header Offset
////////////////////////////////////////////////////////////////////////////////////
function getHeaderOffset() {

  ////////////////////////////////////////////////////////////////////////////////////
  // Variables
  ////////////////////////////////////////////////////////////////////////////////////
  var headerOuterHeight = 0;

  ////////////////////////////////////////////////////////////////////////////////////
  // Get Sticky Header Outer Height
  ////////////////////////////////////////////////////////////////////////////////////
  if (jQuery('header').hasClass('js-sticky-top')) {
    headerOuterHeight = jQuery('header').outerHeight() + 20;
  }

  ////////////////////////////////////////////////////////////////////////////////////
  // Return Header Outer Height
  ////////////////////////////////////////////////////////////////////////////////////
  return headerOuterHeight;

}

////////////////////////////////////////////////////////////////////////////////////
// Menu - Sticky Scroll Menu
////////////////////////////////////////////////////////////////////////////////////
function sticky_scroll_header() {
  var header = jQuery("body").find('header');
  var scroll = jQuery(window).scrollTop();
  var scroll_depth = 200;

  if (scroll >= scroll_depth) {
    header.addClass("scrolled");
  } else {
    header.removeClass("scrolled");
  }
  
  jQuery(window).scroll(function () {
    var scroll = jQuery(window).scrollTop();

    if (scroll >= scroll_depth) {
      header.addClass("scrolled");
    } else {
      header.removeClass("scrolled");
    }
  });
}

////////////////////////////////////////////////////////////////////////////////////
// Mandrill JSON Payload
////////////////////////////////////////////////////////////////////////////////////
function mandrill_json_payload(fid) {

  ////////////////////////////////////////////////////////////////////////////////////
  // Declare Form Data Object Array
  ////////////////////////////////////////////////////////////////////////////////////
  var mandrillData = new Object();
  mandrillData.customFields = {}
  var mandrillAttachments = []

  ////////////////////////////////////////////////////////////////////////////////////
  // Mandrill Settings
  ////////////////////////////////////////////////////////////////////////////////////
  mandrillData.recipients = jQuery(fid).data('form-recipients'); // Form Recipients
  mandrillData.fromName = jQuery(fid).data('form-from-name'); // From Name
  mandrillData.fromEmail = jQuery(fid).data('form-from-email-address'); // From Email Address
  mandrillData.subjectLine = jQuery(fid).data('form-subject-line'); // Form Subject Line
  mandrillData.notificationCopy = jQuery(fid).data('form-email-body'); // Email Body Copy

  ////////////////////////////////////////////////////////////////////////////////////
  // Get all data fields
  ////////////////////////////////////////////////////////////////////////////////////
  jQuery( fid + ' *[data-field-name]' ).each(function( index, value ) {

    ////////////////////////////////////////////////////////////////////////////////////
    // Grouped Field Type - Checkboxs | Radio Buttons
    ////////////////////////////////////////////////////////////////////////////////////
    if(jQuery(this).is('[data-field-group]')) {

      var groupedID = jQuery(this).data('field-group');
      var groupedValue = [];

      ////////////////////////////////////////////////////////////////////////////////////
      // Push Array of checked fields
      ////////////////////////////////////////////////////////////////////////////////////
      jQuery( this ).find('[name="' + groupedID + '"]').each(function( index ) {
        if(jQuery(this).is(':checked')) {
          groupedValue.push(jQuery(this).val());
        }
      });

      ////////////////////////////////////////////////////////////////////////////////////
      // Append Group Data to data
      ////////////////////////////////////////////////////////////////////////////////////
      if(groupedValue.length) {
        mandrillData.customFields[jQuery(this).data('field-name')] = groupedValue.join();
      }

    ////////////////////////////////////////////////////////////////////////////////////
    // Standard Field Type
    ////////////////////////////////////////////////////////////////////////////////////
    } else {
      mandrillData.customFields[jQuery(this).data('field-name')] = jQuery(this).val();
    }

  });

  ////////////////////////////////////////////////////////////////////////////////////
  // Attachments
  ////////////////////////////////////////////////////////////////////////////////////
  jQuery( fid + ' *[data-file-base-64]' ).each(function( index, value ) {

    mandrillAttachments.push({
      'name' : jQuery(this).attr('data-filename'),
      'type' : jQuery(this).attr('data-mimetype'),
      'content' : jQuery(this).attr('data-file-base-64')
    });

  });

  ////////////////////////////////////////////////////////////////////////////////////
  // Assign Attachments
  ////////////////////////////////////////////////////////////////////////////////////
  if(mandrillAttachments.length > 0) {
    mandrillData['attachments'] = mandrillAttachments;
  }

  ////////////////////////////////////////////////////////////////////////////////////
  // Return Data
  ////////////////////////////////////////////////////////////////////////////////////
  return JSON.stringify(mandrillData);

}

////////////////////////////////////////////////////////////////////////////////////
// NOUS Anchor Link Hash
////////////////////////////////////////////////////////////////////////////////////
function nous_anchor_link_hash(hash) {
  // Exclude "Chosen" (https://harvesthq.github.io/chosen/) dropdowns from hash scroll
  // as they are not compatible with the scroll to hash functionality
  // - no hash present, results in a JS error
  if (jQuery(this).hasClass('chosen-single')) {
    return;
  }
  
  // Fixed Nav Offset
  var header_offset = getHeaderOffset();
  
  // Scroll to w/ Animation
  if(jQuery('*[data-scroll-element="' + hash + '"]').length) {
    jQuery('html, body').animate({
      scrollTop: jQuery('*[data-scroll-element="' + hash + '"]').offset().top - header_offset
    }, 0);
  }
}

////////////////////////////////////////////////////////////////////////////////////
// NOUS Scroll to Filter
////////////////////////////////////////////////////////////////////////////////////
function scrollToSectionIfJournalCategory() {
  // Use jQuery to get the current URL's query parameters
  var urlParams = new URLSearchParams(window.location.search);

  // Check if the 'journal-category' parameter exists
  if (urlParams.has('journal-category')) {
    // Scroll to the specific section (replace '.js-filter-block' with your section's selector)
    var $targetSection = jQuery('.js-filter-block');

    if ($targetSection.length) {
      jQuery('html, body').animate({
        scrollTop: $targetSection.offset().top
      }, 800); // 800ms for smooth scrolling
    }
  }
}

////////////////////////////////////////////////////////////////////////////////////
// Flexi Block: Ticker Tape
////////////////////////////////////////////////////////////////////////////////////
function flexi_ticker_tape(wrapperClass) {
  const containers = document.querySelectorAll(wrapperClass);

  if (!containers) return; // Exit if the containers is not found

  containers.forEach(container => {
    var parentContainer = container.parentNode;
    const textContent = container.innerHTML;
    
    let duplicateContent = '';
    let duplicatesNeeded = 0;

    let tapeDirection = container.getAttribute('data-tape-direction');

    let currentPosition = - (container.offsetWidth / 2);

    // Determine how many duplicates are needed based on parentContainer's width
    if (tapeDirection === "left") {
      duplicatesNeeded = Math.ceil(parentContainer.offsetWidth / container.offsetWidth);
    } else if (tapeDirection === "right") {
      duplicatesNeeded = Math.ceil(parentContainer.offsetWidth / container.offsetWidth);
    }

    for (let i = 0; i < duplicatesNeeded; i++) {
      duplicateContent += textContent;
    }

    // Set the duplicated content
    container.innerHTML = duplicateContent;

    const speed = 1; // Adjust speed: higher is slower
    let animationFrameId;

    function animateScroll() {
      if (tapeDirection === "left") {
        currentPosition += speed;
        if (currentPosition >= parentContainer.offsetWidth) {
          currentPosition = - 0;
        }
        container.style.transform = `translate3d(${currentPosition}px, 0, 0)`;
      } else if (tapeDirection === "right") {
        currentPosition -= speed;
        if (currentPosition <= -parentContainer.offsetWidth) {
          currentPosition = 0;
        }
        container.style.transform = `translate3d(${currentPosition}px, 0, 0)`;
      }

      animationFrameId = requestAnimationFrame(animateScroll); // Smooth animation
    }

    // Function to pause animation
    function pauseAnimation() {
      cancelAnimationFrame(animationFrameId);
    }

    // Function to resume animation
    function resumeAnimation() {
      animateScroll();
    }

    // Event listeners to pause and resume animation on hover and touch
    ['mouseenter', 'touchstart'].forEach(event => {
      container.addEventListener(event, pauseAnimation);
    });

    ['mouseleave', 'touchend'].forEach(event => {
      container.addEventListener(event, resumeAnimation);
    });

    animateScroll(); // Start the animation

  });
}
////////////////////////////////////////////////////////////////////////////////////

////////////////////////////////////////////////////////////////////////////////////
// Flexi Block: Stockist Module || FAQ Module
////////////////////////////////////////////////////////////////////////////////////
function flexi_category_toggle_block(
  $category_class,      // Button / Category Class
  $category_dropdown,   // Bootstrap Dropdown Class
  $category_content     // Accordion Wrapper Class
) {
  jQuery(document).ready(function ($) {

    $(document).on('click', $category_class, function () {
      var $this = $(this);
      var $stockist_active_category_text = $this.text();
      var $product_variant_id = $this.attr('id');
      var $wrapper = $this.closest($category_dropdown);
    
      // Remove 'active' class from all buttons within the wrapper
      $wrapper.find($category_class).removeClass('active');
    
      // Add 'active' class to the clicked button
      $this.addClass('active');

      // Set the data-active-variant attribute of the wrapper to the clicked button's ID
      $wrapper.attr('data-active-category', $product_variant_id);

      // Update Dropdown Toggle Text
      $wrapper.parent().find('.dropdown-toggle .text').text($stockist_active_category_text);
    });

    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'data-active-category') {
          $stockist_categories_content = $('body').find($category_content);
          $active_category_info = $stockist_categories_content.find($category_class + '#' + mutation.target.getAttribute('data-active-category'));

          $active_category_info.siblings().addClass('d-none').removeClass('d-flex');
          $active_category_info.addClass('d-flex').removeClass('d-none');
        }
      });
    });
    
    // Observe changes to the `.js-product-variants` div
    $($category_dropdown).each(function () {
      observer.observe(this, { attributes: true });
    });

  });
}

////////////////////////////////////////////////////////////////////////////////////
// Flexi Block: Products
////////////////////////////////////////////////////////////////////////////////////
function flexi_products_block() {
  (function($) {

    const flexi_blocks = $('.section-flexi-products');

    flexi_blocks.each(function() {
      var flexi_block = $(this);
      var more_products_btn = flexi_block.find('.js-product-grid-show-more');

      more_products_btn.on('click', function () {
        var hide_text = $(this).find('.hide-text');
        var default_text = $(this).find('.default-text');

        $(this).toggleClass('active');

        var product_grid = flexi_block.find('.js-product-grid');
        var product_grid_items = product_grid.find('.js-product-grid-item');
        product_grid_items.each(function() {
          var grid_item = $(this);
          grid_item.toggleClass('d-none').toggleClass('d-flex');
        });

        default_text.toggleClass('d-none');
        hide_text.toggleClass('d-none');

        jQuery('html, body').animate({
          scrollTop: product_grid.offset().top - 100
        }, 0);
      });

    });

  })(jQuery);
}

////////////////////////////////////////////////////////////////////////////////////
// Document Ready
////////////////////////////////////////////////////////////////////////////////////
jQuery( document ).ready(function($) {

  ////////////////////////////////////////////////////////////////////////////////////
  // Anchor Link Hash
  ////////////////////////////////////////////////////////////////////////////////////
  $(document).on('click', 'a', function() {

    var hash = $(this).attr('href').split('#');
    nous_anchor_link_hash(hash[1]);

  });

  ////////////////////////////////////////////////////////////////////////////////////
  // Site Wide Variables
  ////////////////////////////////////////////////////////////////////////////////////
  var nousThemeName = $('body').attr('data-nous-theme');
  var googleMapStyles = [{"featureType":"all","elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#333333"},{"lightness":40}]},{"featureType":"all","elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"lightness":16}]},{"featureType":"all","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#fefefe"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#fefefe"},{"lightness":17},{"weight":1.2}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":20}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":21}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#dedede"},{"lightness":21}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#ffffff"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":16}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#f2f2f2"},{"lightness":19}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#e9e9e9"},{"lightness":17}]}];

  ////////////////////////////////////////////////////////////////////////////////////
  // Determine if is retina device
  ////////////////////////////////////////////////////////////////////////////////////
  function isRetinaDisplay() {
    if (window.matchMedia) {
      var mq = window.matchMedia("only screen and (min--moz-device-pixel-ratio: 1.3), only screen and (-o-min-device-pixel-ratio: 2.6/2), only screen and (-webkit-min-device-pixel-ratio: 1.3), only screen  and (min-device-pixel-ratio: 1.3), only screen and (min-resolution: 1.3dppx)");
      return (mq && mq.matches || (window.devicePixelRatio > 1));
    }
  }

  ////////////////////////////////////////////////////////////////////////////////////
  // Base64 File
  ////////////////////////////////////////////////////////////////////////////////////
  function base64File(file, onLoadCallback) {
      return new Promise(function(resolve, reject) {
          var reader = new FileReader();
          reader.onload = function() { resolve(reader.result); };
          reader.onerror = reject;
          reader.readAsDataURL(file);
      });
  }

  ////////////////////////////////////////////////////////////////////////////////////
  // Generate Munchkin Hash
  ////////////////////////////////////////////////////////////////////////////////////
  function generate_munchkin_hash(email) {

    return $.ajax({
      type: "POST",
      url: '/wp-admin/admin-ajax.php',
      data: 'email=' + email + '&action=generate_munchkin_hash',
      dataType: 'json',
    });

  }

  ////////////////////////////////////////////////////////////////////////////////////
  // Google Maps Init
  ////////////////////////////////////////////////////////////////////////////////////
  function init_google_map() {

    ////////////////////////////////////////////////////////////////////////////////////
    // Each Google Map
    ////////////////////////////////////////////////////////////////////////////////////
    $( '.js-init-google-map' ).each(function( index ) {

        ////////////////////////////////////////////////////////////////////////////////////
        // Variables
        ////////////////////////////////////////////////////////////////////////////////////
        var myLatLng = {lat: $(this).data('lat'), lng: $(this).data('lng')};
        // var mapInfoWindow = $(this).attr('data-info-window');
        // var markerIcon = new google.maps.MarkerImage('/wp-content/themes/' + nousThemeName + '/assets/img/map-marker.png', null, null, null, new google.maps.Size(30,40));


        ////////////////////////////////////////////////////////////////////////////////////
        // Create Map
        ////////////////////////////////////////////////////////////////////////////////////
        var map = new google.maps.Map(document.getElementById($(this).attr('id')), {
          zoom: 12,
          center: myLatLng,
          styles: googleMapStyles
        });

        ////////////////////////////////////////////////////////////////////////////////////
        // Create Marker
        ////////////////////////////////////////////////////////////////////////////////////
        var marker = new google.maps.Marker({
          position: myLatLng,
          map: map,
        });

        ////////////////////////////////////////////////////////////////////////////////////
        // Create Info Window
        ////////////////////////////////////////////////////////////////////////////////////
        var infowindow = new google.maps.InfoWindow({
          content: mapInfoWindow,
          // pixelOffset: new google.maps.Size(5, 20)
        });
        infowindow.open(map, marker);

    }); // END EACH

  }

  ////////////////////////////////////////////////////////////////////////////////////
  // Onload Functionality
  ////////////////////////////////////////////////////////////////////////////////////
  $(window).load(function() {

      ////////////////////////////////////////////////////////////////////////////////////
      // Hash Onload Scroll To Functionality
      ////////////////////////////////////////////////////////////////////////////////////
      if(window.location.hash) {

        setTimeout(function() {

          var hash = window.location.hash;
          hash = hash.split('#');

          nous_anchor_link_hash(hash[1]);

        }, 500);

      } // END HASH

      ////////////////////////////////////////////////////////////////////////////////////
      // Initialize Google Map
      ////////////////////////////////////////////////////////////////////////////////////
      init_google_map();

      ////////////////////////////////////////////////////////////////////////////////////
      // Trunc8 Function
      ////////////////////////////////////////////////////////////////////////////////////
      $( '.js-trunc8' ).each(function( index ) {

        var lineCount = $(this).attr('data-trunc8-line');

        $(this).trunk8({
          lines: parseInt(lineCount)
        });

      });

  }); // END ONLOAD


  ////////////////////////////////////////////////////////////////////////////////////
  // Clear input on focus
  ////////////////////////////////////////////////////////////////////////////////////
  $(document).on('focus', '.js-clear-input', function() {

    $(this).val('');

    return false;

  });

  ////////////////////////////////////////////////////////////////////////////////////
  // Initialize Marketo Instance
  ////////////////////////////////////////////////////////////////////////////////////
  // $.ajax({
  //   url: '//munchkin.marketo.net/munchkin.js',
  //   dataType: 'script',
  //   cache: true,
  //   success: function() {
  //     Munchkin.init('[KEY]');
  //   }
  // });

  ////////////////////////////////////////////////////////////////////////////////////
  // Save To Disk Function
  ////////////////////////////////////////////////////////////////////////////////////
  // function SaveToDisk(fileURL, fileName) {
  //     // for non-IE
  //     if (!window.ActiveXObject) {
  //         var save = document.createElement('a');
  //         save.href = fileURL;
  //         save.target = '_blank';
  //         save.download = fileName || 'unknown';

  //         var evt = new MouseEvent('click', {
  //             'view': window,
  //             'bubbles': true,
  //             'cancelable': false
  //         });
  //         save.dispatchEvent(evt);

  //         (window.URL || window.webkitURL).revokeObjectURL(save.href);
  //     }

  //     // for IE < 11
  //     else if ( !! window.ActiveXObject && document.execCommand)     {
  //         var _window = window.open(fileURL, '_blank');
  //         _window.document.close();
  //         _window.document.execCommand('SaveAs', true, fileName || fileURL)
  //         _window.close();
  //     }
  // }

  ////////////////////////////////////////////////////////////////////////////////////
  // Scroll To Event
  ////////////////////////////////////////////////////////////////////////////////////
  // $(document).on('click', '.js-scroll-to', function() {

  //   // Scroll to
  //   var scrollTo = $(this).attr('data-scroll-to');

  //   // Header Position Offset
  //   if($('.header-top').css('position') === 'fixed') {
  //     var headerHeight = $('.js-navbar-fixed-top').outerHeight();
  //   } else {
  //     var headerHeight = 0;
  //   }

  //   $('html, body').animate({
  //    scrollTop: $('*[data-scroll-element="' + scrollTo + '"]').offset().top
  //   }, 0);

  //   return false;

  // });

  ////////////////////////////////////////////////////////////////////////////////////
  // Marketo IE10 Bug fix
  ////////////////////////////////////////////////////////////////////////////////////
  (function () {
    'use strict';
    if (navigator.userAgent.match(/IEMobile\/10\.0/)) {
      var msViewportStyle = document.createElement('style')
      msViewportStyle.appendChild(
        document.createTextNode(
          '@-ms-viewport{width:auto!important}'
        )
      )
      document.querySelector('head').appendChild(msViewportStyle)
    }
  })();

  ////////////////////////////////////////////////////////////////////////////////////
  // File Type - Data Attributes
  ////////////////////////////////////////////////////////////////////////////////////
  $(document).on('change', '.js-base64-file', function() {

     ////////////////////////////////////////////////////////////////////////////////////
     // Base64 File Contents
     ////////////////////////////////////////////////////////////////////////////////////
     var inputID = $(this).attr('id');
     var fileInput = document.querySelector('#' + inputID).files[0];

     ////////////////////////////////////////////////////////////////////////////////////
     // Assign Base64 to file
     ////////////////////////////////////////////////////////////////////////////////////
     var fileInputBase64 = base64File(fileInput, function(e) {
     }).then(function(result) {
      var formatted = result.split(',');
      $('#' + inputID).attr('data-file-base-64', formatted[1]);
     });

     ////////////////////////////////////////////////////////////////////////////////////
     // Assign other attributes to file input
     ///////////////////////////////////////////////////////////////////////////////////
     $('#' + inputID).attr('data-filename', fileInput.name);
     $('#' + inputID).attr('data-mimetype', fileInput.type);

  });

  ////////////////////////////////////////////////////////////////////////////////////
  // FAQ accordion toggle functionality
  ////////////////////////////////////////////////////////////////////////////////////
  $(document).on('click', '.js-panel', function() {

      $('.panel-collapse').removeClass('in');

      if($(this).parent('.panel').hasClass('active')) {
        $(this).parent('.panel').removeClass('active');
        $(this).siblings('.panel-collapse').removeClass('in');
      } else {
        $('.js-panel').parent('.panel').removeClass('active');
        $(this).parent('.panel').addClass('active');
        $(this).siblings('.panel-collapse').addClass('in');
      }

      return false;
  });

  ////////////////////////////////////////////////////////////////////////////////////
  // jQuery Validate Phone Method - Uses Google Lib
  ////////////////////////////////////////////////////////////////////////////////////
  $.validator.addMethod("validPhone", function(value, element) {

      if(value == '') { return true; }

      try {

          var phoneUtil = i18n.phonenumbers.PhoneNumberUtil.getInstance();
          var number = phoneUtil.parseAndKeepRawInput(value, 'AU');

          if(phoneUtil.isValidNumber(number)) {

              return true;

          } else {

              return false;

          }

      }
      catch(ex) {
          return false;
          console.log(ex);
      }

  }, "Please enter a valid phone number (including area code for land lines)");

});